import { useLocation } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { AddressDetailCard, ButtonDiv, OrderDetail } from "./helper";

/**
 * AddressSuccess
 * Renders the success page after address verification, displays address and order details.
 */
const AddressSuccess = () => {
    const location = useLocation();
    const orders = location.state.orders;
    const addressData = location.state.address;

    return (

        <>
            <div className="d-flex flex-column gap-2 mt-2 justify-content-center align-items-center">
                <div className="d-flex align-items-center">
                    <img src={toAbsoluteUrl('/media/images/checked1.png')} style={{ width: '32px', height: '32px' }} alt="imagechecked" className="me-2" />
                    <span className="fs-1 fw-semibold">Thank You</span>
                </div>
                <div className="fs-4 fw-normal mt-1 text-center">Your redemption will be delivered at this address.</div>
            </div>
            <div className='card p-2 ps-4 mt-2' style={{ backgroundColor: "#FBF6F7", border: "0.5px solid #f2f2f2" }}>
                <div className='fs-6 fw-semibold mt-1'> Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
            </div>
            <AddressDetailCard addressData={addressData} />
            <OrderDetail orders={orders} />
            <ButtonDiv btn1={{ label: 'Support', url: "/customer/address/support", class: "btn btn-lg w-150px rounded-4 btn-dark" }} btn2={{ label: 'Exit', url: "", class: "btn btn-lg w-150px rounded-4 btn-danger" }} />
        </>


    )

}

export default AddressSuccess